import withUiBase from './withUiBase';

function SelectUIBase({ uiBase, children }) {
  if (uiBase === 'kiddie') {
    return children[0];
  }
  return children[1];
}

export default withUiBase(SelectUIBase);



// WEBPACK FOOTER //
// ./src/app/ui/config/SelectUIBase.js